module.exports = __webpack_public_path__ + "img/checkout_complete.daf3c468.svg";